import { create } from 'zustand'

interface State {
  isOpen: boolean
}

interface Actions {
  // Opens the two-step verification dialog mounted by the profile menu, from anywhere in the app.
  openEnrollment: VoidFunction
  closeEnrollment: VoidFunction
}

export const useTwoFactorEnrollmentState = create<State & Actions>((set) => ({
  isOpen: false,
  openEnrollment() {
    set({ isOpen: true })
  },
  closeEnrollment() {
    set({ isOpen: false })
  },
}))
